module.exports = __webpack_public_path__ + "img/13.42d67fb0.png";